import React, { useEffect, useState } from "react";
import './testcards.minimal.css';

// Minimal-change TestCards: keeps original single-grid UI but includes both
// individual tests and the 4 composite (pre-built) interview flows as cards
// All cards live together in one grid. Selecting a composite clears individual selections and vice versa.

export default function TestCardsMinimal({ onSelectTestCard }) {
  const [selectedTestCard, setSelectedTestCard] = useState([]); // holds route or composite id

  const cards = [
    // Individual tests (original)
    { id: "/screening", title: "Screening Test", description: "Quickly assess a candidate's core skills and competencies." },
    { id: "/communication", title: "Communication Test", description: "Evaluate a candidate's ability to communicate clearly and professionally." },
    { id: "/personality-test", title: "Personality Test", description: "Gain insights into personality traits and cultural fit." },
    { id: "/behavioral-test", title: "Behavioral Test", description: "Assess approach to workplace challenges and teamwork." },
    { id: "/all-test", title: "Personality & Behavioral Test", description: "Combined personality and behavioral evaluation." },
    { id: "/icoding", title: "Coding Test", description: "Assess coding ability with realistic problems." },

    // Composite pre-built flows (use ids prefixed with "flow:")
    { id: "flow:sc", title: "Screening + Coding — 1 hr", description: "30m Screening → 30m Coding" },
    { id: "flow:spb", title: "Screening + Personality & Behavioral — 1 hr", description: "30m Screening → 30m P&B" },
    { id: "flow:scp", title: "Screening + Coding + P&B — 1.5 hr", description: "30m Screening → 30m Coding → 30m P&B" },
    { id: "flow:spc20", title: "Screening + P&B + Coding — 1 hr (20/20/20)", description: "20m Screening → 20m P&B → 20m Coding" },
  ];

  const toggleCard = (card) => {
    const isFlow = card.id.startsWith("flow:");

    setSelectedTestCard((prev) => {
      // If a flow is selected, selecting any individual clears flows and vice versa
      const prevContainsFlow = prev.some(id => id.startsWith("flow:"));
      const prevContainsInd = prev.some(id => !id.startsWith("flow:"));

      // If selecting a flow and previously had individual selections -> clear and set flow
      if (isFlow) {
        // toggle behavior for flows: only one flow allowed at a time
        if (prev.includes(card.id)) return prev.filter(id => id !== card.id);
        return [card.id];
      } else {
        // selecting individual: remove flows first
        const withoutFlows = prev.filter(id => !id.startsWith("flow:"));
        if (withoutFlows.includes(card.id)) return withoutFlows.filter(id => id !== card.id);
        return [...withoutFlows, card.id];
      }
    });
  };

  const handleConfirm = () => {
    if (onSelectTestCard) onSelectTestCard(selectedTestCard);
  };

  return (
    <div className="tc-min-wrap">
      <div className="tc-min-header">
        <div>
          <div className="tc-min-title">Select Tests & Interview Flows</div>
          <div className="tc-min-sub">Choose individual tests or select one pre-built interview flow. All cards appear together for quick selection.</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 12, color: '#64748b' }}>Selected</div>
          <div style={{ fontWeight: 800 }}>{selectedTestCard.length} chosen</div>
        </div>
      </div>

      <div className="tc-min-grid">
      {cards.map((c) => {
        // create safe unique class name from id: remove slashes/colons and spaces
        const uid = c.id.replace(/[:\/]/g, "").replace(/\s+/g, "-").replace(/[^a-zA-Z0-9_-]/g, "");
        return (
          <div
            key={c.id}
            className={`tc-min-card tc-card-${uid} ${selectedTestCard.includes(c.id) ? "selected" : ""}`}
            onClick={() => toggleCard(c)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => (e.key === "Enter" ? toggleCard(c) : null)}
          >
            <h4>{c.title}</h4>
            <p>{c.description}</p>
            <div className={`flow-badge ${c.id.startsWith("flow:") ? "flow" : "ind"}`}>
              {c.id.startsWith("flow:") ? "Pre-built Flow" : "Individual Test"}
            </div>
          </div>
        );
      })}
      </div>

      <div className="tc-min-footer">
        <div style={{ color: '#334155', fontWeight: 700 }}>
          {/* {selectedTestCard.length === 0 ? 'No selection' : selectedTestCard.join(', ')} */}
        </div>
        <div>
          <button className="confirm-btn" onClick={handleConfirm} disabled={selectedTestCard.length === 0}>Confirm Selection</button>
        </div>
      </div>
    </div>
  );
}
